import { useState } from 'react'
import { formatScorecardStatusLabel } from '@/features/scorecard/scorecard-status'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'
import { Typography } from '@/components/ui/typography'
import { useBoardEdit } from '@/features/ogsm/board-edit-context'
import { OGSM_COPY } from '@/features/ogsm/ogsm-labels'
import { OGSM_STATUS_OPTIONS } from '@/features/ogsm/status-options'
import { StatusMark } from '@/components/custom/ogsm/status-mark'
import type { OgsmBoardNode } from '@/types/api'

/** The status mark; a popover to change it when the backend allows readings. */
export function StatusControl({ node }: { node: OgsmBoardNode }) {
  const { session, saveNode } = useBoardEdit()
  const [open, setOpen] = useState(false)
  if (!session.readingsEditable) return <StatusMark status={node.status} />

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label={OGSM_COPY.changeStatus}
          className="inline-flex shrink-0 cursor-pointer items-center rounded-full"
        >
          <StatusMark status={node.status} />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-52 p-1.5">
        <Typography
          variant="overline"
          className="block px-2 py-1.5 text-primary/60"
        >
          {OGSM_COPY.status}
        </Typography>
        {OGSM_STATUS_OPTIONS.map((status) => (
          <button
            key={status}
            type="button"
            className="flex w-full cursor-pointer items-center gap-2 rounded-md px-2 py-1.5 text-left text-sm hover:bg-primary/5"
            onClick={() => {
              setOpen(false)
              if (status !== node.status) saveNode(node.id, { status })
            }}
          >
            <StatusMark status={status} decorative />
            {formatScorecardStatusLabel(status)}
          </button>
        ))}
      </PopoverContent>
    </Popover>
  )
}
